	ele.print = (function(){
		// Create the print area div
		var printarea = $('<div class="printarea"></div>');
		// Executes print
		var printArea = function(){
			$('body').addClass('printing').append(printarea);
			window.print();
			// The print area is cleared and removed after use
			setTimeout(function(){			
				$('body').removeClass('printing');
				printarea.remove();
				printarea = $('<div class="printarea"></div>');
			},1000);
		};
		// Public methods
		return {
			text: function(text){
				printarea.text(text);
				printArea();
			},
			// Prints the content of an element
			elem: function(elem){

                printarea.append(elem.clone());
                printArea();

			},
			// Prints the page returned from an ajax call
			ajax: function(url){
				$.ajax({
					url: url,
					method: 'get',
					success: function(data){
						printarea.append(data);
						printArea();
					}
				});
			},
			
			printContent: function(selector) {
				if (selector != "") {
					ele.print.elem($(selector))
				} else {
					ele.print.elem($('body'))
				}
			}
		};
	})();	
